<template>
  <div id="index">


    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="$refs.addEdit.show()" icon="el-icon-plus" v-auth="'/secondhand/attachment/add'">添加附件</el-button>
    </div>

    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="list" >
          <el-table-column prop="name" label="附件名称"></el-table-column>
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column prop="create_time" label="添加时间"></el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button @click="$refs.addEdit.show(scope.row)" type="text" size="small" v-auth="'/secondhand/attachment/edit'">编辑</el-button>
              <el-button @click="deleteTap(scope.row)" type="text" size="small" v-auth="'/secondhand/attachment/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="pagination">
      <el-pagination
        @current-change="pageChange"
        background
        :current-page="searchObj.page"
        :page-size="searchObj.list_rows"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>


    <AddEdit ref="addEdit" @refresh="getData"></AddEdit>


  </div>
  </template>

  <script>
  import AddEdit from './addEdit.vue';
  import SecondhandApi from '@/api/secondhand'
  export default {
    components:{AddEdit},
    data() {
      return {
        searchObj:{
          page:1,
          list_rows:10,
        },
        list: [],
        total:0,
      }
    },
    created(){
      this.getData()
    },
    methods:{

      getData(){
        SecondhandApi.attachmentIndex(this.searchObj).then(result=>{
          let list=result.data.list
          this.list=list.data
          this.total=list.total
        })
      },

      // 删除
      deleteTap(e){
        this.$confirm('确认删除当前附件吗？','提示',{type: 'warning'}).then(() => {
          SecondhandApi.attachmentDelete({attachment_id:e.attachment_id}).then(result=>{
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getData()
          })
        })
      },

      // 分页
      pageChange(e){
        this.searchObj.page=e
        this.getData()
      },

    }
  }
  </script>

  <style lang="scss" scoped>
  </style>


// WEBPACK FOOTER //
// src/views/secondhand/attachment/index.vue